import { AssignmentTurnedInOutlinedIcon, Flex, Text } from '@shared/components';

interface EmptyExamEventResultOverlayProps {
  subTitle?: string;
  endAdornment?: JSX.Element;
}

export default function EmptyExamEventResultOverlay(
  props: Readonly<EmptyExamEventResultOverlayProps>,
) {
  const { endAdornment, subTitle } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(4),
        py: theme.spacing(20),
        height: '100%',
      })}
    >
      <AssignmentTurnedInOutlinedIcon
        sx={(theme) => ({ fontSize: '100px', color: theme.palette.grey[400] })}
      />
      <Flex
        sx={(theme) => ({ flexDirection: 'column', alignItems: 'center', gap: theme.spacing(2) })}
      >
        <Text variant='h3'>ยังไม่มีข้อมูลผลการสอบ</Text>
        {subTitle ? <Text>{subTitle}</Text> : null}
      </Flex>
      {endAdornment ? endAdornment : null}
    </Flex>
  );
}
